<template>
  <div class="container">

    <div v-if="errors" class="alert alert-danger">
      <div>Please check the following errors.</div>
      <ul class="mb-0 pl-4 small">
        <template v-for="error_group in errors">
          <li :key="k" v-for="(error,k) in error_group">{{ error }}</li>
        </template>
      </ul>
    </div>

    <div class="row">
      <div class="col-md-4 offset-md-4">

        <div class="text-center py-4">
          <img :src="logo" style="height:80px">
        </div>

        <div class="card border-0 shadow-sm">
          <div class="card-header bg-transparent">Select a store</div>
          <div class="card-body">

            <div v-if="fetchingStores" class="text-center">
              <i class="fas fa-circle-notch fa-spin"></i> Fetching your stores...
            </div>

            <div v-if="fetchingStoresError" class="alert alert-danger mb-0">
              <i class="fas fa-times mr-1"></i> Failed to fetch your stores. Please try again.
            </div>

            <div v-if="stores">
              <div v-if="stores.length===0" class="text-center text-muted">
                😟 You do not have any stores assigned
              </div>
              <div v-else class="list-group list-group-flush" style="margin:-20px">
                <button v-for="(store, k) in stores" :key="k" @click.prevent="handleStoreSelection(store)" type="button" :class="'list-group-item list-group-item-action ' + (store === selectedStore ? 'active' : '')">
                  <span class="store-name">
                    {{ store.name }}
                    <span class="float-right">
                      <i v-if="fetchingApiKey && store === selectedStore" class="fas fa-circle-notch fa-spin"></i>
                      <i v-else class="fas fa-arrow-right"></i>
                    </span>
                  </span>
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Stores',
  data () {
    return {
      logo: process.env.URL_LOGO,
      adminEndpoint: process.env.URLS_ADMIN,
      fetchingStores: true,
      fetchingStoresError: false,
      stores: null,
      selectedStore: null,
      fetchingApiKey: false,
      fetchingApiKeyError: false,
      errors: null
    }
  },
  created () {
    this.fetchStores()
  },
  methods: {
    fetchStores () {
      this.$store.dispatch('setStore', null)

      this.errors = null

      axios.get(process.env.URLS_POS_API + '/stores').then(response => {
        this.stores = response.data.data

        if (this.stores.length === 1) {
          this.handleStoreSelection(this.stores[0])
        }
      }).catch(error => {
        let errorMessage = (error.response && error.response.data && error.response.data.message) || 'An unknown error occurred. Please try again!'
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)

        this.errors = error.response.data.errors || null
        this.fetchingStoresError = true
      }).finally(() => {
        this.fetchingStores = false
      })
    },
    handleStoreSelection (store) {
      this.selectedStore = store
      this.$store.dispatch('setStore', store)
      this.fetchApiKey()
    },
    fetchApiKey () {
      this.fetchingApiKey = true
      this.errors = null

      this.$store.dispatch('generateOrSetApiKey', this.selectedStore).then(() => {
        this.$router.push({ name: 'home' })
      }).catch(error => {
        let errorMessage = (error.response && error.response.data && error.response.data.message) || 'An unknown error occurred. Please try again!'
        let errorDescription = (error.response && error.response.data && error.response.data.description) || null
        this.$toast.error(errorMessage, errorDescription)

        this.errors = (error.response && error.response.data && error.response.data.errors) || null
        this.fetchingApiKeyError = true
        this.selectedStore = null
      }).finally(() => {
        this.fetchingApiKey = false
      })
    }
  }
}
</script>

<style scoped>
  .store-name {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Stores.vue